import { useEffect, useState } from 'react'
import { Users } from 'lucide-react'
import { fetchCompany, cachedCompany, fetchFriendPositions } from '../lib/company'
import { companyLine, friendLineParts } from '../lib/companyLine'
import { Avatar } from './Avatar'

// ── CompanyLine ────────────────────────────────────────────────────────────────
// "3 others watching · 1 near you · 2 marked this week", under a show's title on
// the deck card and the show page. Anonymous counts from show_company(); renders
// nothing until there is someone to mention, so the line never says zero. Tapping
// it opens the companions door (onOpen), the one place names appear.
export function CompanyLine({ showId, user, me, onOpen, tone = 'page', style }) {
  const [row, setRow] = useState(() => cachedCompany(showId) ?? null)
  // Who's with you: the first person you follow on this show, by episode (2026-10-18).
  const [friend, setFriend] = useState(null)
  useEffect(() => {
    let alive = true
    if (!showId || !user?.id) { setFriend(null); return }
    fetchFriendPositions(showId, 3).then(rows => { if (alive) setFriend(rows[0] || null) })
    return () => { alive = false }
  }, [showId, user?.id])
  useEffect(() => {
    let alive = true
    if (!showId || !user?.id) { setRow(null); return }
    const hit = cachedCompany(showId)
    if (hit !== undefined) { setRow(hit); return }
    fetchCompany(showId).then(r => { if (alive) setRow(r) })
    return () => { alive = false }
  }, [showId, user?.id])
  const text = companyLine(row)
  const onCard = tone === 'card'
  const color = onCard ? 'rgba(var(--photo-ink-rgb),0.72)' : 'var(--text-dim)'
  const flp = friend ? friendLineParts(me, friend) : null
  const fl = flp ? flp.name + flp.rest : null
  if (!text && !fl) return null
  // data-noswipe on both: the deck card treats any press as a tap-to-rate; these
  // buttons opt out of the card's pointer engine (same as the ⋯ button).
  const btn = { display: 'inline-flex', alignItems: 'center', background: 'none', border: 'none', padding: '6px 8px 6px 0', margin: '-6px 0', cursor: onOpen ? 'pointer' : 'default', fontFamily: 'var(--font)', lineHeight: 1.3, textAlign: 'left' }
  const stop = { onClick: (e) => { e.stopPropagation(); onOpen?.() }, onPointerUp: (e) => e.stopPropagation() }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start', ...style }}>
      {fl && (
        <button type="button" data-noswipe {...stop} aria-label={`${fl}. See who`} className="ui-hit" style={{ ...btn, gap: 7, fontSize: onCard ? 13.5 : 13, color: onCard ? '#fff' : 'var(--text)' }}>
          <Avatar name={friend.name_private ? friend.username : (friend.display_name || friend.username)} avatarUrl={friend.avatar_url} size={onCard ? 20 : 18} />
          <span><b style={{ color: 'var(--social)' }}>{flp.name}</b>{flp.rest}</span>
        </button>
      )}
      {text && (
        <button type="button" data-noswipe {...stop} aria-label={`${text}. See who`} className="ui-hit" style={{ ...btn, gap: 6, fontSize: onCard ? 13 : 12.5, color }}>
          <Users size={onCard ? 13 : 12} style={{ flexShrink: 0, opacity: 0.85 }} />
          <span>{text}</span>
        </button>
      )}
    </div>
  )
}
